import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {NotifierService} from 'angular-notifier';
import {MessageService} from '../message.service';
import {RestApiService} from '../rest-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SocketService} from '../socket.service';

@Component({
    selector: 'app-dashboard-citapp',
    templateUrl: './dashboard-citapp.component.html',
    styleUrls: ['./dashboard-citapp.component.css']
})
export class DashboardCitappComponent implements OnInit, OnDestroy {

    clientName: string;
    userGroups: any;
    userGroupId: number;
    groupName: string;
    grpLevel: number;
    respObject: any;
    tilesData = [];
    isLabel0: boolean;
    isLabel1: boolean;
    isLabel2: boolean;
    isLabel3: boolean;
    islead: boolean;
    cat1: any;
    cat2: any;
    cat3: any;
    catName1: string;
    catName2: string;
    catName3: string;
    private userAuth: Subscription;
    private ticketSub: Subscription;
    userGroupSelected: number;
    private ticketType: number;
    ticketTypeLoaded = false;
    radioButton = [];
    selectedData = [];
    private notifier: NotifierService;
    modal: any;
    radius: number;
    clientId: number;
    categories = [];
    categorySelected: number;
    errorMessage: string;
    isError = false;
    users = [];
    userSelected: number;
    @ViewChild('content') content;
    private dashboardSubscribe: Subscription;
    isLoading: boolean;
    workType: string;
    workspaces = [];
    isCrType: boolean;
    isPrType: boolean;
    typeSeq: number;
    showScheduleTicket: boolean;
    isAdmin: boolean;
    isSearchFaq: boolean;
    isTicketTypeDisable: boolean;
    load: boolean;

    constructor(private messageService: MessageService, private _rest: RestApiService,
                private actRoute: ActivatedRoute, private route: Router, notifier: NotifierService,
                private modalService: NgbModal, private socketService: SocketService) {
        this.notifier = notifier;
        this.dashboardSubscribe = this.socketService.dashboardSubject.subscribe((data) => {
            if (this.userGroupId === data.groupId) {
                // console.log('-->: ' + JSON.stringify(data));
                const menuId = data.menuId;
                const displayelem = document.getElementById('display_' + menuId);
                if (displayelem !== undefined && displayelem !== null) {
                    displayelem.classList.remove('none');
                }
                const countelem = document.getElementById('count_' + menuId);
                if (countelem !== undefined && countelem !== null) {
                    countelem.innerText = (Number(countelem.innerText) + 1) + '';
                }
            }
        });
    }


    ngOnInit() {
        this.isTicketTypeDisable = false;
        this.isSearchFaq = false;
        this.isAdmin = false;
        this.showScheduleTicket = true;
        this.typeSeq = 0;
        this.isCrType = false;
        this.isPrType = false;
        this.isLoading = false;
        this.radius = 65;
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.isLabel3 = false;
        this.islead = false;
        this.categorySelected = 0;
        this.userSelected = 0;
        this.actRoute.queryParams.subscribe(params => {
            const token = params['token'];
            this.clientId = params['clientId'];
            const encodedUserName = params['name'];
            const userId = params['userId'];
            let userName;
            if (encodedUserName) {
                userName = this.messageService.xorEncode(atob(encodedUserName), this.messageService.SECRET_TOKEN);
            }
            this.catName1 = params['cat1'];
            this.catName2 = params['cat2'];
            const sourceType = params['srcType'];
            const ticketType1 = params['ticket_type1'];
            this.catName3 = params['cat3'];
            let callback = params['callback'];
            let count = 0;
            let isIncident = false;
            // let isProblem = false;

            // // console.log(ticketType1, typeof ticketType1);
            if (this.clientId !== undefined && token !== undefined && userName !== undefined) {
                // // console.log('from panel');
                if (callback === 'undefined' || callback === undefined || callback === '') {
                    callback = this.messageService.API_ROOT;
                }
                if (sourceType !== 'undefined' && sourceType !== undefined && sourceType !== '') {
                    this.messageService.saveSourceType(sourceType);
                }
                if (ticketType1 !== 'undefined' && ticketType1 !== undefined && ticketType1 !== '') {
                    if (this.catName1 === 'undefined' || this.catName1 === undefined || this.catName1 === '') {
                        alert(this.messageService.CATEGORY1_ERROR);
                        window.location.href = callback;
                    }
                    if (this.catName2 === 'undefined' || this.catName2 === undefined || this.catName2 === '') {
                        alert(this.messageService.CATEGORY2_ERROR);
                        window.location.href = callback;
                    }
                    if (this.catName3 === 'undefined' || this.catName3 === undefined || this.catName3 === '') {
                        alert(this.messageService.CATEGORY3_ERROR);
                        window.location.href = callback;
                    }
                    count++;
                }
                if (count === 0 && sourceType !== 'ADFS') {
                    alert(this.messageService.NO_TICKET_TYPE);
                    window.location.href = callback;
                } else {
                    this.messageService.clearSession();
                    const data = {clientId: this.clientId, token: token, loginName: userName};

                    this._rest.tokenValidation(data).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            // sessionStorage.setItem('id', this.respObject.details);
                            // sessionStorage.setItem('data', token);
                            this.messageService.addSessionData(this.respObject.details, token, this.clientId);
                            this.messageService.tokenSubject.next();
                            sessionStorage.removeItem('dd');
                            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                                this.clientName = auth[0].client;
                                this.userGroups = auth[0].groupId;
                                // console.log(this.messageService.getSupportGroup());
                                // if (this.messageService.getSupportGroup() === null) {
                                if (this.userGroups !== undefined) {
                                    this.userGroupId = this.userGroups[0].groupId;
                                    this.groupName = this.userGroups[0].grpName;
                                    this.grpLevel = this.userGroups[0].level;
                                }
                                this.userGroupSelected = this.userGroupId;
                                // this.name = userName;
                                // console.log('-----token validation-------');
                                if (sourceType !== 'ADFS') {
                                    this._rest.getCatfromUrl(this.clientId, ticketType1, this.catName1,
                                        this.catName2, this.catName3).subscribe((res1) => {
                                        this.respObject = res1;
                                        if (this.respObject.success) {
                                            this.messageService.saveCategory1({
                                                cat1: this.respObject.details.cat1,
                                                cat2: this.respObject.details.cat2,
                                                cat3: this.respObject.details.cat3
                                            });
                                            // this.onPageLoad();
                                            if (this.messageService.createUrl !== undefined && this.messageService.createUrl !== null) {
                                                this.messageService.changeRouting(this.messageService.createUrl);
                                            }
                                        } else {
                                        }
                                    });
                                } else {
                                    this.onPageLoad();
                                }
                                // }
                            });
                            // this.onPageLoad();
                        } else {
                            this.messageService.clearSession();
                            alert(this.messageService.URL_TOKEN_ERROR1);
                            window.location.href = callback;
                            // console.log(this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.messageService.clearSession();
                        alert(this.messageService.TOKEN_TIMEOUT_ERROR);
                        window.location.href = callback;
                    });
                }
            } else if (token !== undefined && userId !== undefined) {
                this.messageService.addSessionData(this.messageService.xorEncode(atob(userId), this.messageService.SECRET_TOKEN), token, this.clientId);
                this.messageService.tokenSubject.next();
                sessionStorage.removeItem('dd');
                this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                    this.clientName = auth[0].client;
                    this.clientId = auth[0].clientId;
                    this.userGroups = auth[0].groupId;
                    if (this.userGroups !== undefined) {
                        this.userGroupId = this.userGroups[0].groupId;
                        this.groupName = this.userGroups[0].grpName;
                        this.grpLevel = this.userGroups[0].level;
                    }
                    this.userGroupSelected = this.userGroupId;
                    this.onPageLoad();
                });
            } else {
                if (this.messageService.getUserId() === null || this.messageService.getToken() === null) {
                    this.messageService.clearSession();
                    // console.log('inside else')
                    window.location.href = this.messageService.API_ROOT;
                } else {
                    // this.sourceType = 'web';
                    if (this.messageService.clientId) {
                        this.clientId = this.messageService.clientId;
                        this.clientName = this.messageService.client;
                        this.userGroups = this.messageService.groupId;
                        if (this.userGroups !== undefined) {
                            if (this.messageService.getSupportGroup() === null) {
                                this.userGroupId = this.userGroups[0].groupId;
                                this.groupName = this.userGroups[0].grpName;
                                this.grpLevel = this.userGroups[0].level;
                            } else {
                                const group = this.messageService.getSupportGroup();
                                this.userGroupId = group.groupId;
                                this.groupName = group.grpName;
                                this.grpLevel = group.level;
                            }
                            this.userGroupSelected = this.userGroupId;
                        }
                        // console.log('-----within page-------');
                        this.onPageLoad();
                    } else {
                        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                            this.clientId = auth[0].clientId;
                            this.clientName = auth[0].client;
                            this.userGroups = auth[0].groupId;
                            if (this.userGroups !== undefined) {
                                if (this.messageService.getSupportGroup() === null) {
                                    this.userGroupId = this.userGroups[0].groupId;
                                    this.groupName = this.userGroups[0].grpName;
                                    this.grpLevel = this.userGroups[0].level;
                                } else {
                                    const group = this.messageService.getSupportGroup();
                                    this.userGroupId = group.groupId;
                                    this.groupName = group.grpName;
                                    this.grpLevel = group.level;
                                }
                                this.userGroupSelected = this.userGroupId;
                            }
                            // console.log('-----page refresh-------');
                            this.onPageLoad();
                            // }
                        });
                    }
                }
            }
        });
    }

    onPageLoad() {
        this.isLoading = true;
        this.tilesData = [];
        if (this.userGroupId) {

            if (this.grpLevel === 0) {
                this.workspaces = [{id: '1', name: 'My Workspace'}];
                // this.workType = '1';
            } else if (this.grpLevel > 0 && this.grpLevel < 3) {

                this.workspaces = [{id: '1', name: 'My Workspace'}, {id: '2', name: 'Team Workspace'}];
                // this.workType = '1';
            } else {

                this.workspaces = [{id: '2', name: 'Team Workspace'}];
                // this.workType = '2';
                //   console.log("work"+this.workType);
            }
            this.ticketSub = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
                this.respObject = res1;
                this.ticketTypeLoaded = true;
                if (this.respObject.success) {
                    this.radioButton = this.respObject.details;
                    const storage = JSON.parse(sessionStorage.getItem('dd'));
                    this.radioButton[0].checked = false;
                    this.load = false;
                    if (storage === null) {
                        this.categorySelected = 0;
                        this.userSelected = 0;
                        this.showHideBtn();
                        for (let i = 0; i < this.radioButton.length; i++) {
                            if (this.radioButton[i].view_sequence === 2) {
                                this.ticketType = this.radioButton[i].id;
                                this.radioButton[i].checked = true;
                                this.typeSeq = this.radioButton[i].seq;
                                break;
                            }
                        }
                        this.messageService.saveMenuData({
                            type: this.ticketType,
                            seq: this.typeSeq,
                            user: this.userSelected,
                            cat: this.categorySelected
                        });
                    } else {
                        const type = storage.type;
                        this.typeSeq = storage.seq;
                        this.showHideBtn();

                        for (let i = 0; i < this.radioButton.length; i++) {

                            if (this.radioButton[i].id === type) {
                                this.ticketType = this.radioButton[i].id;
                                this.typeSeq = this.radioButton[i].seq;
                                this.radioButton[i].checked = true;
                                this.load = true;
                                break;
                            }
                        }


                        if (!this.load) {
                            for (let i = 0; i < this.radioButton.length; i++) {
                                if (this.radioButton[i].view_sequence === 2) {
                                    this.ticketType = this.radioButton[i].id;
                                    this.radioButton[i].checked = true;
                                    // this.typeSeq = this.radioButton[i].seq;
                                    break;
                                }

                            }

                        }
                        this.categorySelected = storage.cat;
                        this.userSelected = storage.user;
                    }
                    this._rest.checkIsLead(this.clientId, this.userGroupId, this.messageService.getUserId()).subscribe((res3) => {
                        this.respObject = res3;
                        if (this.respObject.success) {
                            this.islead = this.respObject.details[0].is_spoc;
                            // // console.log('this.islead:' + this.islead);

                            // ========================================================
                            console.log('this.grpLevel===' + this.grpLevel);
                            if ((this.grpLevel === 1) || this.grpLevel >= 2) {
                                this.getCategory();
                            }
                            if (this.grpLevel >= 3) {
                                this._rest.getAllLevelOneAndLevelTwoUser(this.clientId).subscribe((res5) => {
                                    this.respObject = res5;
                                    if (this.respObject.success) {
                                        this.isError = false;
                                        // // console.log(this.respObject);
                                        this.respObject.details.unshift({id: 0, name: 'Select Analyst'});
                                        this.users = this.respObject.details;
                                        // this.userSelected = 0;
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    // this.isError = true;
                                    // this.errorMessage = this.messageService.SERVER_ERROR;
                                });
                            }
                            // ==========================================================
                            // end user and l1 => dash bord detls
                            //   l1 lead => getDashBoardDtlsForTeamLead
                            //   l2 -l5 new api => getDashBoardDtlsForLeader
                            this.getDynamicMenu_new();
                        } else {

                        }
                    });

                } else {
                    this.isLoading = false;
                }
            });
        } else {
            this.ticketTypeLoaded = true;
            this.isLoading = false;
        }
        if (this.grpLevel === 0 && this.grpLevel !== undefined) {
            this.isLabel0 = true;
        } else if (this.grpLevel === 1 && this.grpLevel !== undefined) {
            this.isLabel1 = true;
        } else if (this.grpLevel === 2 && this.grpLevel !== undefined) {
            this.isLabel2 = true;
        } else if (this.grpLevel >= 3 && this.grpLevel !== undefined) {
            this.isLabel3 = true;
        } else {
            this.isAdmin = true;
            if (this.islead === true) {
                this.isSearchFaq = false;
            } else {
                this.isSearchFaq = true;
            }
            this.showScheduleTicket = false;
        }

    }

    getDynamicMenu_new() {
        this.isLoading = true;
        const wstorage = this.messageService.getWorkspace();

        if (wstorage !== null) {
            // this.workType = wstorage;
            let matched = false;
            for (let i = 0; i < this.workspaces.length; i++) {
                if (this.workspaces[i].id === wstorage) {
                    this.workType = wstorage;
                    matched = true;
                    break;
                }
            }
            if (!matched) {
                this.workType = this.workspaces[0].id;
            }
        } else {
            this.workType = this.workspaces[0].id;
        }
        this.messageService.setWorkspace(this.workType);
        this.isTicketTypeDisable = true;
        this._rest.getDynamicMenuTicketTypeWise(this.clientId, this.ticketType,
            this.messageService.getUserId(), 1, this.userGroupId, this.workType).subscribe((res2) => {
            this.respObject = res2;
            // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                this.isTicketTypeDisable = false;
                this.tilesData = [];
                this.selectedData = this.respObject.details;
                this.isLoading = false;
                this.tilesData = this.selectedData;
                for (let i = 0; i < this.selectedData.length; i++) {
                    // this._rest.getDashBoardDtls_new(this.clientId, this.userGroupId, this.ticketType,
                    this._rest.getDynamicTotCountMenuTicketDtls_new(this.clientId, this.userGroupId, this.ticketType,this.typeSeq,
                        this.selectedData[i].fid, this.categorySelected, this.userSelected).subscribe((res) => {
                        this.respObject = res;
                        // // console.log('data--Done=======', this.respObject);
                        if (this.respObject.success) {
                            document.getElementById('loader_' + this.respObject.details[0].id).hidden = true;
                            document.getElementById('count_' + this.respObject.details[0].id).innerText = this.respObject.details[0].value;
                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                    });
                }
                this._rest.checkOfflineDashNotification(this.clientId, this.userGroupId,
                    this.messageService.getUserId(), this.ticketType, 1).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        const result = this.respObject.details;
                        // this.menus = this.respObject.details;
                        for (let i = 0; i < result.length; i++) {
                            const menuId = result[i].noti_type;
                            const displayelem = document.getElementById('display_' + menuId);
                            if (displayelem !== undefined && displayelem !== null) {
                                displayelem.classList.remove('none');
                            }

                        }
                    }
                });
                // // console.log('++++++++++++', JSON.stringify(this.tilesData));
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    createTicket() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // this.route.navigate(['ticket/createTicketL&T']);
        if (this.messageService.createUrl !== undefined && this.messageService.createUrl !== null) {
            this.messageService.changeRouting(this.messageService.createUrl);
        }
    }

    onButtonChange(selectedButton) {
        // console.log('+++++++++++++++++', selectedButton.value.seq, selectedButton.value.id, this.grpLevel);
        this.ticketType = selectedButton.value.id;
        this.typeSeq = selectedButton.value.seq;
        this.showHideBtn();
        this.messageService.saveMenuData({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        });
        this.getCategory();
        this.getDynamicMenu_new();
    }

    showHideBtn() {
        if (this.typeSeq === 5 && this.grpLevel > 2) {
            this.isCrType = false;
            this.showScheduleTicket = false;
        } else if (this.typeSeq === 5) {
            this.isCrType = true;
            this.showScheduleTicket = true;
        } else {
            this.isCrType = false;
            this.isAdmin = true;
        }
        if (this.typeSeq === 6 && this.grpLevel > 2) {
            this.isPrType = false;
            this.showScheduleTicket = false;
        } else if (this.typeSeq === 6) {
            this.isPrType = true;
            this.showScheduleTicket = true;
        } else {
            this.isPrType = false;
            this.isAdmin = true;
        }

        if (this.typeSeq < 5) {
            this.showScheduleTicket = true;
        }
        // console.log('############===' + this.isLabel0, this.isLabel1, this.isLabel2, this.isAdmin);
    }

    getCategory() {
        this._rest.getCategoryListSupportGroupWise(this.userGroupId, this.clientId,
            this.ticketType).subscribe((res4) => {
            this.respObject = res4;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, name: 'Select Applications'});
                this.categories = this.respObject.details;
                this.categorySelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.isError = true;
            // this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    goto(fid) {
        // // console.log('**********************', fid);

        sessionStorage.setItem('dd', JSON.stringify({
            id: fid,
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        if (this.messageService.viewUrl !== undefined && this.messageService.viewUrl !== null) {
            this.messageService.changeRouting(this.messageService.viewUrl);
        }
        // this.route.navigate(['ticket/viewTicketL&TSSC']);
    }

    onSelectGroup() {
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.isLabel3 = false;
        this.islead = false;
        this.ticketTypeLoaded = true;
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            if (this.grpLevel === 0 && this.grpLevel !== undefined) {
                this.isLabel0 = true;
                this.workType = '1';
                this.messageService.setWorkspace(this.workType);
            } else if (this.grpLevel === 1 && this.grpLevel !== undefined) {
                this.isLabel1 = true;
            } else if (this.grpLevel === 2 && this.grpLevel !== undefined) {
                this.isLabel2 = true;
            } else if (this.grpLevel >= 3 && this.grpLevel !== undefined) {
                this.isLabel3 = true;
                this.workType = '2';
                this.messageService.setWorkspace(this.workType);
            } else {
                this.isAdmin = true;
                this.showScheduleTicket = false;
            }
            this.showHideBtn();
            this.messageService.saveSupportGroup({
                groupId: this.userGroupId,
                grpName: this.groupName,
                level: this.grpLevel
            });

            // console.log('-----change group-------');
            this.onPageLoad();
        }
    }

    onSelectCategory() {
        this.userSelected = 0;
        this.getDynamicMenu_new();
    }

    onSelectUser() {
        this.categorySelected = 0;
        this.getDynamicMenu_new();
    }

    ngOnDestroy() {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }

        if (this.ticketSub) {
            this.ticketSub.unsubscribe();
        }
        if (this.dashboardSubscribe) {
            this.dashboardSubscribe.unsubscribe();
        }
    }

    goTofaq() {
        // this.route.navigate(['ticket/faq']);
        if (this.messageService.faqUrl !== undefined && this.messageService.faqUrl !== null) {
            this.messageService.changeRouting(this.messageService.faqUrl);
        }
    }

    goToSearch() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            user: this.userSelected,
            cat: this.categorySelected,
            seq: this.typeSeq,
        }));
        // this.route.navigate(['ticket/search']);
        if (this.messageService.searchUrl !== undefined && this.messageService.searchUrl !== null) {
            this.messageService.changeRouting(this.messageService.searchUrl);
        }
    }

    goToScheduleTicket() {
        // console.log('AAAAAAAAAAAAA===' + this.messageService.scheduleTicketUrl);
        if (this.messageService.scheduleTicketUrl !== undefined && this.messageService.scheduleTicketUrl !== null) {
            this.messageService.changeRouting(this.messageService.scheduleTicketUrl);
        }
    }

    onWorkTypeChange() {
        // this.wor
        console.log(this.workType);
        this.messageService.setWorkspace(this.workType);
        this.getDynamicMenu_new();
    }
}
